export const defaultDialogState = {
  open: false,
  dialogBodyText: '',
  onConfirm: () => {},
  cancelText: 'Cancelar',
  confirmText: 'Confirmar',
}
